const items = [
  "Consulenza Specialistica SumUp",
  "Nessun Canone a Sorpresa",
  "Risposta Diretta in 24 Ore",
  "Trasparenza Contrattuale Totale",
];

export function Tape() {
  const doubled = [...items, ...items];
  return (
    <section
      data-testid="editorial-tape"
      className="py-3 bg-[#1B4D3E] text-[#F6F5F2] overflow-hidden font-sans text-xs uppercase tracking-widest font-semibold"
      aria-hidden="true"
    >
      <div className="mq-track gap-10 items-center">
        {doubled.map((item, i) => (
          <span key={i}>✦ {item}</span>
        ))}
      </div>
    </section>
  );
}
